import { render, staticRenderFns } from "./jiandian.vue?vue&type=template&id=9fac77b8&scoped=true&"
import script from "./jiandian.vue?vue&type=script&lang=js&"
export * from "./jiandian.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fac77b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2022/thScoreShop/thScoreAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9fac77b8')) {
      api.createRecord('9fac77b8', component.options)
    } else {
      api.reload('9fac77b8', component.options)
    }
    module.hot.accept("./jiandian.vue?vue&type=template&id=9fac77b8&scoped=true&", function () {
      api.rerender('9fac77b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/setting/systemCreator/systemConfig/bonusConfig/bounsCond/jiandian.vue"
export default component.exports